// src/components/reports/precon-report-builder/precon-draft.ts
import type { PreconCover } from "./precon-types";

export interface PreconSectionDraft {
  level: string;
  grid_lines: string;
  location: string;
  notes: string[];
}

export interface PreconDraft {
  headerBanner: string;
  cover: PreconCover;
  sectionMeta: Record<string, PreconSectionDraft>; // keyed by plan_id
}

const key = (projectId: string) => `otus:precon-draft:${projectId}`;

export function writePreconDraft(projectId: string, draft: PreconDraft): void {
  try {
    localStorage.setItem(key(projectId), JSON.stringify(draft));
  } catch {
    /* storage unavailable — session-only, no persistence */
  }
}

export function readPreconDraft(projectId: string): PreconDraft | null {
  try {
    const raw = localStorage.getItem(key(projectId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") return null;
    return parsed as PreconDraft;
  } catch {
    return null;
  }
}
